import { type JsonDataItem } from '@g2u/ui-kit';
import { baseQuery } from '../baseQuery';

export const getServiceSelectionRates = async ({ id, type, date }: JsonDataItem) => {
  const { data } = await baseQuery(
    `service-selection-rates?service_selection_id=${id}&service_type=${type}&appointment_date=${date}`, // 2024-06-06
  );

  return data;
};
